import React, { useEffect, useState, useRef, useMemo } from 'react';
import AddProduct from './AddProduct';
import ProductList from './ProductList';
import StandardTotal from './StandardTotal';
import { Typeahead } from '../../../components';
import { useProduct } from '../../../context/productContext/ProductContextProvider';
import { useProposal } from '../../../context/proposalContext/ProposalContextProvider';
import { ModalProvider } from '../../../components/common/modal/ModalContext';
import { useModal } from '../../../components/common/modal/ModalContext';
import CreateProduct from '../../setting/product/CreateProduct';
import QuoteModel from '@/model/proposal/QuoteProduct.model';

const ProductSection = () => {
  const { getAllProduct, proposalProducts } = useProduct();
  const [searchQuery, setSearchQuery] = useState('');
  const { openModal, closeModal } = useModal();
  const [productRes, setProductRes] = useState([]);

  const {
    productForEdit,
    setProductForEdit,
    isProductSelected,
    setIsProductSelected,
    setEditProdIndex,
  } = useProposal();

  const typeaheadRef = useRef(null); // To access Typeahead instance and clear input
  const { initialState } = QuoteModel();

  useEffect(() => {
    setIsProductSelected(false);
    setProductForEdit(initialState);
    setEditProdIndex(null);
  }, []);

  useEffect(() => {
    const debounceFetch = setTimeout(() => {
      const fetchProducts = async () => {
        if (searchQuery.length >= 3) {
          const res = await getAllProduct(searchQuery);
        }
      };
      fetchProducts();
    }, 300); // 300ms debounce time

    return () => {
      clearTimeout(debounceFetch);
      // isMounted = false; // Cleanup on unmount
    };
  }, [searchQuery]);

  const productOption = useMemo(() => {
    return proposalProducts?.map((product) => ({
      label:
        product.itemCode +
        ' - ' +
        product.itemDescription +
        ' - ' +
        product.apnManuf +
        ' - ' +
        `<strong>  $ ${product.avgCost}</strong>` +
        (product.inPronto === null || product.inPronto === undefined
          ? ''
          : product.inPronto
            ? ' <span style="float: right; color: green; font-weight: bold;">in pronto</span>'
            : ' <span style="float: right; color: red; font-weight: bold;">not in pronto</span>'),
      value: product.id,
      data: product,
    }));
  }, [proposalProducts]);

  const handleProductSelect = (selected) => {
    if (selected.length > 0) {
      const selectedProduct = selected[0].data;
      setProductForEdit((prev) => ({
        ...prev,
        mainProduct: selectedProduct,
      }));
      setIsProductSelected(true); // Disable Typeahead after selection
      if (typeaheadRef.current) {
        typeaheadRef.current.clear();
      }
    }
  };

  useEffect(() => {
    if (
      productForEdit &&
      productForEdit.mainProduct &&
      productForEdit.mainProduct.id
    ) {
      setIsProductSelected(true);
    } else {
      setIsProductSelected(false);
    }
  }, [productForEdit]);

  const createNewProduct = () => {
    openModal(
      <CreateProduct
        closeModal={closeModal}
        prodCode={searchQuery}
        isCreatedFromProposal={true}
      />,
      'Add Product',
    );
  };

  return (
    <div className="flex min-w-full text-base">
      <div className="flex flex-col w-5/6 z-0">
        <div className="w-10/12">
          <Typeahead
            inputClassName="product-typeahead"
            ref={typeaheadRef}
            label="Add Product"
            onQueryChange={setSearchQuery}
            options={productOption}
            labelKey="label"
            customHeight={true}
            disabledCreateNew={false}
            handleCreateNew={createNewProduct}
            onChange={handleProductSelect}
            disabled={isProductSelected} // Disable when a product is selected
            placeholder="Choose a product (add at least 3 words to search)"
          />
        </div>
        {/* Section 1: 70% width */}
        {isProductSelected && (
          <div className="flex z-0">
            <AddProduct />
          </div>
        )}
        <div className="flex-grow overflow-y-auto">
          <ProductList />
        </div>
      </div>
      <div className="w-1/6 h-[80vh] flex items-center fixed right-0 top-auto bottom-auto z-10 bg-white">
        {/* Section 2: 20% width */}
        <StandardTotal />
      </div>
    </div>
  );
};

const App = () => (
  <ModalProvider>
    <ProductSection />
  </ModalProvider>
);
export default App;
